import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PaymentSummaryDto } from "../../shared/dtos/payment/PaymentSummaryDto";
import {
  getInitialListState,
  generateListReducers,
  ListState,
} from "../utils/listFactory";
import { ServerStatusPayload } from "../../shared/interfaces/ServerStatusPayload";

interface PaymentState extends ListState<PaymentSummaryDto> {
  loadingStkPush: boolean;
  errorStkPush: string | null;
  serverStatus: ServerStatusPayload | null;
}

const initialState: PaymentState = {
  ...getInitialListState<PaymentSummaryDto>(),
  loadingStkPush: false,
  errorStkPush: null,
  serverStatus: null,
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    ...generateListReducers<PaymentSummaryDto>(),
    setLoadingStkPush(state) {
      state.loadingStkPush = true;
      state.errorStkPush = null;
    },
    setErrorStkPush(state, action: PayloadAction<string | null>) {
      state.loadingStkPush = false;
      state.errorStkPush = action.payload;
    },
    setStkPushSuccess(state) {
      state.loadingStkPush = false;
    },
    setServerStatus(state, action: PayloadAction<ServerStatusPayload | null>) {
      state.serverStatus = action.payload;
    },
  },
});

export const paymentActions = paymentSlice.actions;
export default paymentSlice.reducer;
